/* eslint-disable no-self-assign */
import report from '@/api/report'
import get from 'lodash/get'
/* eslint-disable require-yield */

const INITIAL_STATE = {
  reprotDao: null,
  emailTempLogReports: null,
  phishCampaignReport: null,
  actionGroup: null,
  reprotHistories: null,
  tempResults: null,
  deptReportGroups: null,
  officeReportGroups: null,
  osCounts: null,
  userPhishLog: null,
  UserPhishLogTable: null,
  sampleData: null,
  sampleCourseData: null,
  courseReportData: null,
}

export default {
  namespace: 'report',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setReprotDao(state, { payload }) {
      return { ...state, reprotDao: payload }
    },
    setPhishCampaignReport(state, { payload }) {
      return { ...state, phishCampaignReport: payload }
    },
    setEmailTempLogReport(state, { payload }) {
      return { ...state, emailTempLogReports: payload }
    },
    setActionGroup(state, { payload }) {
      return { ...state, actionGroup: payload }
    },
    setCampaignHistory(state, { payload }) {
      return { ...state, reprotHistories: payload }
    },
    setTempResults(state, { payload }) {
      return { ...state, tempResults: payload }
    },
    setDeptReportGroups(state, { payload }) {
      return { ...state, deptReportGroups: payload }
    },
    setOfficeReportGroups(state, { payload }) {
      return { ...state, officeReportGroups: payload }
    },
    setOsCounts(state, { payload }) {
      return { ...state, osCounts: payload }
    },
    setUserPhishLog(state, { payload }) {
      return { ...state, userPhishLog: payload }
    },
    setUserPhishLogTable(state, { payload }) {
      return { ...state, userPhishLogTable: payload }
    },
    setSampleData(state, { payload }) {
      return { ...state, sampleData: payload }
    },
    setSampleCourseData(state, { payload }) {
      return { ...state, sampleCourseData: payload }
    },
    setCourseReportData(state, { payload }) {
      return { ...state, courseReportData: payload }
    },
  },

  effects: {
    *getEmailReprotWithReportDetail(
      { payload, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getEmailReprotWithReportDetail, {
        params: { accountId: get(account, 'accountId') },
        data: payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setReprotDao', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getSampleData({ successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getSampleData, {
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({
            type: 'report/setSampleData',
            payload: { ...data },
          })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getSampleCourseData({ successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getSampleCourseData, {
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined

          yield put({
            type: 'report/setSampleCourseData',
            payload: data,
          })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getCourseReportData({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getCourseReportData, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined

          yield put({
            type: 'report/setCourseReportData',
            payload: data,
          })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getReportTrainingCamps({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getReportTrainingCamps, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getPhishCampaignReport({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getPhishCampaignReport, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setPhishCampaignReport', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getEmailTempLogReport({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getEmailTempLogReport, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setEmailTempLogReport', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getPhishEmailAction({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getPhishEmailAction, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setActionGroup', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getPhishCampaignHistory({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const { campaignId, startDate, endDate } = payload
      const response = yield call(report.getCampaignHistory, {
        params: {
          accountId: get(account, 'accountId'),
          startDate,
          endDate,
        },
        campaignId,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setCampaignHistory', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getUserPhishDepartment({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getUserPhishDepartment, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setDeptReportGroups', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getUserPhishOffice({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getUserPhishOffice, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setOfficeReportGroups', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getTempResultReport({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getTempResultReport, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setTempResults', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getOperatingSystemReport({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getOperatingSystemReport, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setOsCounts', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getUserPhishLogList({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getUserPhishLogList, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setUserPhishLog', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getUserPhishLogTable({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(report.getUserPhishLogTable, {
        params: { accountId: get(account, 'accountId') },
        ...payload,
      })

      const { status, data: resData } = response
      let error = ''

      if (status === 200) {
        const { success, message, data } = resData

        if (success) {
          error = undefined
          yield put({ type: 'report/setUserPhishLogTable', payload: data })
          successCallback?.(data)
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },
  },
}
